export default __webpack_public_path__ + "static/media/mobile.d31a17cf.jpg";